import React, { useState } from "react";

function Contact() {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const contactInfo = [
    { label: "Head Office", value: "Hyderabad", icon: "bi-geo-alt-fill" },
    { label: "Contact", value: "(+91) 8143964374", icon: "bi-telephone-fill" },
    { label: "Desk", value: "+1 727 - 279 - 6035", icon: "bi-telephone-fill" },
    {
      label: "Sales",
      value: "sales@psritservices.com",
      link: "mailto:sales@psritservices.com",
      icon: "bi-envelope-fill",
    },
    {
      label: "Information",
      value: "info@psritservices.com",
      link: "mailto:info@psritservices.com",
      icon: "bi-envelope-fill",
    },
  ];

  return (
    <>
      <div
        className="position-relative"
        style={{ height: "350px", overflow: "hidden", backgroundColor: "#ccc" }}
      >
        <img
          src="/images/contactUs-banner3.jpg"
          alt="PSR-IT Services Banner"
          onLoad={handleImageLoad}
          className="w-100 h-100"
          style={{
            objectFit: "cover",
            display: "block",
            opacity: imageLoaded ? 1 : 0,
            transition: "opacity 0.9s ease-in-out",
          }}
        />
        <div
          className="position-absolute top-50 start-50 translate-middle text-white text-center"
          style={{ zIndex: 2 }}
        >
          <h1>Contact Us</h1>
          <p className="fs-5">
            We try to be most responsive to your inquiries and emails.
          </p>
        </div>
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background: "rgba(0, 0, 0, 0.4)",
            zIndex: 1,
          }}
        />
      </div>

      <div className="py-5" style={{ backgroundColor: "#2c2c2c" }}>
        <div className="container">
          <div className="row mb-4">
            <div className="col-lg-10 mx-auto">
              <p
                className="text-center px-2"
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: "1.1rem",
                  color: "#f4f4f4",
                  lineHeight: "1.6",
                  fontWeight: "500",
                  maxWidth: "90%",
                  margin: "0 auto",
                }}
              >
                We try to be most responsive to your inquiries and emails. To
                facilitate this, we connect you directly with the people who
                will respond to your emails and calls. You can help us respond
                quickly by choosing the most appropriate contact information for
                your purpose.
              </p>
            </div>
          </div>

          <div className="row g-4 justify-content-center">
            {contactInfo.map((item, index) => (
              <div key={index} className="col-md-6 col-lg-5">
                <div
                  className="text-center h-100 p-4 rounded-4 shadow-sm"
                  style={{
                    background: "#fffcf5",
                    border: "1px solid #ddd",
                  }}
                >
                  <div className="mb-2">
                    <i
                      className={`bi ${item.icon}`}
                      style={{
                        fontSize: "1.5rem",
                        color: "#4a1717",
                      }}
                    ></i>
                  </div>
                  <h5 style={{ color: "#4a1717" }}>{item.label}</h5>
                  {item.link ? (
                    <a
                      href={item.link}
                      className="text-primary"
                      style={{
                        textDecoration: "none",
                        fontSize: "1.1rem",
                      }}
                    >
                      {item.value}
                    </a>
                  ) : (
                    <p
                      className="mb-0"
                      style={{
                        fontSize: "1.1rem",
                        color: "#4a1717",
                      }}
                    >
                      {item.value}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Our Locations Section */}
          <div className="mt-5 pt-5 border-top">
            <div className="text-center mb-4">
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto",
                  backgroundColor: "#4a1717",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="bi bi-geo-alt-fill text-white fs-4" />
              </div>
              <h3 className="mt-3" style={{ color: "#fffcf5" }}>
                Our Locations
              </h3>
              <p className="text-light">Reach us at any of our offices</p>
            </div>

            <div className="row justify-content-center">
              {/* India */}
              <div className="col-md-6 col-lg-5 mb-4 d-flex">
                <div
                  className="p-4 rounded-4 shadow-sm w-100"
                  style={{
                    backgroundColor: "#fffcf5",
                    border: "1px solid #ddd",
                    color: "#4a1717",
                  }}
                >
                  <h5 className="mb-3">
                    <i className="bi bi-geo-alt-fill me-2" />
                    India Offices
                  </h5>

                  <div className="mb-3">
                    <strong>Hyderabad:</strong>
                    <p className="mb-1">Hyderabad, India</p>
                    <p className="mb-0">
                      <i className="bi bi-telephone-fill me-2" />
                      (+91) 9849010044
                    </p>
                  </div>

                  <div>
                    <strong>Bangalore:</strong>
                    <p className="mb-1">Street No. 8, JP Nagar, Bangalore</p>
                  </div>
                </div>
              </div>

              {/* US */}
              <div className="col-md-6 col-lg-5 mb-4 d-flex">
                <div
                  className="p-4 rounded-4 shadow-sm w-100"
                  style={{
                    backgroundColor: "#fffcf5",
                    border: "1px solid #ddd",
                    color: "#4a1717",
                  }}
                >
                  <h5 className="mb-3">
                    <i className="bi bi-geo-alt-fill me-2" />
                    US Offices
                  </h5>

                  <div className="mb-3">
                    <strong>Florida:</strong>
                    <p className="mb-1">
                      555 Winderley Place, Suite 300, Maitland, FL – 32751
                    </p>
                    <p className="mb-0">
                      <i className="bi bi-telephone-fill me-2" />
                      954-305-0699
                    </p>
                  </div>

                  <div>
                    <strong>Ohio:</strong>
                    <p className="mb-1">
                      Suite 106, 6797 N. High Street, Worthington, Ohio 43085
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
